import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE,
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST,
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS,
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING,
} = patientAction;

function* getDownloadCsvTemplate(): SagaReturnType<any> {
  try {
    yield put({ type: GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_LOADING });
    const response = yield call(patientService.getDownloadPatientCSVTemplate);
    if (response?.status === 200) {
      yield put({ type: GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_SUCCESS, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_FAILURE, payload: error });
  }
}

function* getDownloadCsvTemplateSaga() {
  yield takeEvery(GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST, getDownloadCsvTemplate);
}

export default getDownloadCsvTemplateSaga;
